import React, { useEffect, useRef } from "react";
import MainText from "../components/Apply/MainText";
import MainTitle from "../components/Apply/MainTitle";
import ApplyDates from "../components/Apply/ApplyDates";
import BreadCrumbs from "../components/Apply/BreadCrumbs";
import { useTheme } from "@mui/styles";
import { useMediaQuery, Box } from "@mui/material";
import { useCourses } from "../context/CourseContext";
import BackButton from "../components/ApplyForm/BackButton";
import { useLocation } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    width: "100%",
    overflow: "hidden",
  },
  span: { fontWeight: "bold" },
  cardsContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { md: "center" },
    mt: { md: "150px" },
    mb: { xs: "70px", md: "251px" },
  },
  normal: { fontWeight: "normal" },
  coursesContainer: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: "center",
    mb: "39px",
  },
  buttonContainer: {
    width: {
      xl: "1373px",
      lg: "1098px",
      md: "878.4px",
      sm: "284px",
      xs: "284px",
    },
    display: "flex",
    justifyContent: {
      xs: "center",
      sm: "center",
      md: "flex-start",
      lg: "flex-start",
      xl: "flex-start",
    },
  },
});

const ApplyJavascriptDates = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const isMobile = useMediaQuery("(max-width:899px)");

  const { jsBootcampCourses } = useCourses();

  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement) {
      focusOnElement();
    }
  }, []);

  const breadcrumbs = {
    first: {
      text: "Aplicá",
      link: "/aplica",
    },
    second: { text: "", link: "" },
    third: { text: "Edición", link: "" },
  };

  const { pathname } = useLocation();
  const { title, description, img, subtitle } = useTranslation(
    pathname,
    "ApplyJavascriptDates"
  );

  return (
    <Box sx={classes.container}>
      <MainTitle
        title={title}
        subtitle={
          <>
            {description[0]}
            <span style={classes.span}>{description[1]}</span>
          </>
        }
        img={img}
      />

      {!isMobile && (
        <MainText
          text={
            <>
              {subtitle[0]}
              <span style={classes.normal}>{subtitle[1]}</span>
            </>
          }
          mt={{ xs: "-113px", md: "-90px", lg: "-83px", xl: "-100px" }}
        />
      )}

      <BreadCrumbs breadcrumbs={breadcrumbs} />

      <Box sx={classes.coursesContainer} ref={focusElement}>
        {jsBootcampCourses?.length > 0
          ? jsBootcampCourses
              .filter(
                ({ vacancyStatus, availability, status }) =>
                  vacancyStatus && availability && status === "disponible"
              )
              .map((course, index) => {
                return (
                  <ApplyDates
                    course={course}
                    key={index}
                    pathname={"/aplica/javascript/formulario"}
                  />
                );
              })
          : null}
        <Box>
          <Box sx={classes.buttonContainer}>
            <BackButton />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ApplyJavascriptDates;
